/**
 * Properties reducer.
 * @module reducers/toolbar/toolbar
 */

import { GET_G20_SOCIAL_NETWORKS } from '../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  data: { items: [] },
};

/**
 * Site Properties reducer.
 * @function site
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function g20SocialNetworks(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_G20_SOCIAL_NETWORKS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        data: {},
      };
    case `${GET_G20_SOCIAL_NETWORKS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        data: action.result.social_networks,
      };
    case `${GET_G20_SOCIAL_NETWORKS}_FAIL`:
      return {
        ...state,
        error: action.result,
        loaded: false,
        loading: false,
        data: {},
      };
    default:
      return state;
  }
}
